import { Link } from "react-router-dom";

type HeroViewProps = {
  eyebrow: string;
  title: string;
  kicker: string;
  description: string;
  ctaLabel: string;
  ctaHref: string;
  image: string;
  imageAlt: string;
};

export function HeroView({
  eyebrow,
  title,
  kicker,
  description,
  ctaLabel,
  ctaHref,
  image,
  imageAlt,
}: HeroViewProps) {
  return (
    <section id="home" className="section hero hero-section">
      <div className="hero-panel">
        <div className="hero-copy">
          <p className="eyebrow">{eyebrow}</p>
          <h1>{title}</h1>
          {kicker ? <p className="hero-kicker">{kicker}</p> : null}
          <p className="lead">{description}</p>
          <Link to={ctaHref} className="hero-cta">
            {ctaLabel}
          </Link>
        </div>
        <div className="hero-image-wrap">
          <img
            src={image}
            alt={imageAlt}
            className="hero-image"
            loading="eager"
            decoding="async"
            width={734}
            height={1054}
          />
        </div>
      </div>
    </section>
  );
}
